import React, { forwardRef, useState } from 'react';
import { Button, Modal, Form, Checkbox } from 'semantic-ui-react';
import DropdownSearchTripFetch from '../../../components/Formik/DropdownSearchTripFetch';
import { Dropzone, FileItem } from '@dropzone-ui/react';
import FileSaver from 'file-saver';
import * as xlsx from 'xlsx';
import { EXCEL_FILE_BASE64 } from '../constants';

function exampleReducer(state, action) {
  switch (action.type) {
    case 'OPEN_MODAL':
      return { open: true, dimmer: action.dimmer };
    case 'CLOSE_MODAL':
      return { open: false };
    default:
      throw new Error();
  }
}

const ModalTrip = ({ formik, verViaje, setResetConceptos, resetConceptos }) => {
  let { values, errors, touched, handleChange, handleBlur, setFieldValue } =
    formik;

  let [state, dispatch] = React.useReducer(exampleReducer, {
    open: false,
    dimmer: undefined,
  });

  let { open, dimmer } = state;

  const [files, setFiles] = useState([]);
  const [dataFiles, setDataFiles] = useState();
  const updateFiles = (incommingFiles) => {
    //console.log('incomming files', incommingFiles);
    if (incommingFiles) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = xlsx.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        setDataFiles(xlsx.utils.sheet_to_json(worksheet));
      };
      reader.readAsArrayBuffer(incommingFiles[0].file);
    }
    setFiles(incommingFiles);
  };
  const handleDelete = (id) => {
    setFiles(files.filter((x) => x.id !== id));
  };

  const handleDownload = () => {
    let sliceSize = 1024;
    let byteCharacters = window.atob(EXCEL_FILE_BASE64);
    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      let begin = sliceIndex * sliceSize;
      let end = Math.min(begin + sliceSize, bytesLength);
      let bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    FileSaver.saveAs(
      new Blob(byteArrays, { type: 'application/vnd.ms-excel' }),
      'plantilla-conceptos.xlsx'
    );
  };

  return (
    <div>
      
      {
        values.idTipoComprobante !== 'P' && (
          <div style={{ marginBottom: 10 }}>
            <Button onClick={() => dispatch({ type: 'OPEN_MODAL' })} type="button">
              Cargar Viaje
            </Button>
          </div>
        )
      }

      <Modal
        dimmer={dimmer}
        open={open}
        onClose={() => dispatch({ type: 'CLOSE_MODAL' })}
      >
        <Modal.Header>Importar viaje de Optima</Modal.Header>
        <Modal.Content>
          <div style={{ marginBottom: 10 }}>
            <DropdownSearchTripFetch
              fluid
              selection
              label="Número de viaje"
              value={values.TripID}
              onChange={(e, { value }) => setFieldValue('TripID', value)}
              placeholder="Número de viaje"
              featherService="optima-trips"
              columName="TripNumber"
              columValue="TripID"
              mapValues={(value) => {
                return {
                  key: Math.random(),
                  text: `${value['TripNumber']}`,
                  value: value['TripID'],
                };
              }}
              error={errors.TripID && { content: errors.TripID }}
            />
          </div>
          <Form.Field>
            <Button
              compact
              primary
              onClick={handleDownload}
              style={{ marginTop: 16, marginBottom: 16 }}
            >
              Descargar Plantilla
            </Button>
          </Form.Field>
          <Form.Field>
            <label style={{ marginRight: 8 }}>Reiniciar conceptos</label>
            <Checkbox
              toggle
              checked={resetConceptos}
              onChange={(e, { checked }) => {
                console.log( checked );
                setResetConceptos(checked);
              }}
            />
          </Form.Field>
          <Dropzone
            onChange={updateFiles}
            value={files}
            onClean
            // accept={'image/jpeg,.ts, video/*'}
            label={'Arrastrar aquí o dar click para seleccionar. '}
            minHeight={'195px'}
            maxHeight={'500px'}
            disableScroll
            maxFiles={1}
            style={{ marginTop: 8 }}
          >
            {files.map((file) => (
              <FileItem
                {...file}
                key={file.id}
                onDelete={handleDelete}
                alwaysActive
                preview
                info
                resultOnTooltip
              />
            ))}
          </Dropzone>
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => dispatch({ type: 'CLOSE_MODAL' })}>
            Cancelar
          </Button>

          <Button
            positive
            onClick={async () => {
              if (dataFiles) {
                setFieldValue('conceptos', [
                  ...values.conceptos,
                  ...dataFiles.map((concept) => ({ ...concept })),
                ]);
              }
              await verViaje(values.TripID, formik, dataFiles);
              dispatch({ type: 'CLOSE_MODAL' });
              
            }}
          >
            Importar
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default forwardRef((props, ref) => (
  <ModalTrip {...props} innerRef={ref} />
));
